/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Auction_PlaceInputs */

const cs_sreality_attr_auction_place = /** @type {(inputs: Sreality_Attr_Auction_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Místo dražby`)
};

const en_sreality_attr_auction_place = /** @type {(inputs: Sreality_Attr_Auction_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auction place`)
};

/**
* | output |
* | --- |
* | "Auction place" |
*
* @param {Sreality_Attr_Auction_PlaceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_auction_place = /** @type {((inputs?: Sreality_Attr_Auction_PlaceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Auction_PlaceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_auction_place(inputs)
	return cs_sreality_attr_auction_place(inputs)
});